import type {CellContext, RowData} from "@tanstack/react-table";

import {Text} from "@pg-design/text-module";

export const DataTableDefaultCellRenderer = <TData extends RowData>(props: CellContext<TData, unknown>) => (
    <Text variant="body_copy_1">{`${props.getValue()}`}</Text>
);
import type {CellContext, RowData} from "@tanstack/react-table";

import {Text} from "@pg-design/text-module";

export const DataTableDefaultCellRenderer = <TData extends RowData>(props: CellContext<TData, unknown>) => (
    <Text variant="body_copy_1">{`${props.getValue()}`}</Text>
);
